<template>
  <whaty-dialog
    :title="importConfig.title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    width="800px">
    <div class="popup-wrap"
         slot="body"
         v-loading="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="popup-body">
        <div class="popup-content">
          <!-- flow -->
          <div class="flow flow-step3">
            <ul class="clearfix">
              <li class="flow-cell" :class="{'flow-current': activeStep === 1}">
                <span class="flow-name">上传Excel</span>
                <span class="flow-num">1</span>
                <span class="flow-bar"></span>
              </li>
              <li class="flow-cell"  :class="{'flow-current': activeStep === 2}">
                <span class="flow-name">数据预览</span>
                <span class="flow-num">2</span>
                <span class="flow-bar"></span>
              </li>
              <li class="flow-cell"  :class="{'flow-current': activeStep === 3}">
                <span class="flow-name">导入数据</span>
                <span class="flow-num">3</span>
                <span class="flow-bar"></span>
              </li>
            </ul>
          </div>
          <div v-show="activeStep === 1" style="display: none; height: 370px;" class="import-container">
            <div class="import-top">
              <h5>导入EXCEL</h5>
              <ul class="clearfix">
                <li class="import-cell" style="width: 100%;">
                  <div class="import-wrap">
                    <div class="import-content grid-import" style="display: block; height: 100%;">
                      <el-upload
                        class="grid-excel-upload"
                        drag
                        ref="upload_file"
                        :auto-upload="true"
                        :limit="1"
                        :headers="uploadHeaders"
                        :name="'upload'"
                        :data="computedUploadExtraParams"
                        :action="computedUploadUrl"
                        :on-progress="uploadProgress"
                        :on-success="uploadSuccess"
                        :on-error="uploadError">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      </el-upload>
                    </div>
                    <span class="assist"></span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="import-bot">
              <ul class="clearfix">
                <li class="import-cell">
                  <p class="info">
                    温馨提示<br>
                    按模板要求填写，带 * 为必填项<br>
                    模板列顺序可调整，非必填项可以为空或删除整列
                  </p>
                </li>
                <li class="import-cell">
                  <p class="info">
                    第一步，下载<a @click="downloadTemplate" class="btn-link" style="font-weight: bold;">Excel模板</a>，填写数据<br>
                    第二步，上传文件 ，预览数据<br>
                    第三步，检查结果
                  </p>
                </li>
              </ul>
            </div>.
          </div>
          <div v-if="activeStep === 2" class="import-container">
            <div class="import-top">
              <h5>预览数据：{{fileName}}</h5>
              <div style="border: 1px solid #ddd;">
                <el-scrollbar>
                  <div style="max-height: 268px;">
                    <table style="min-width: 100%;" border="1" cellspacing="0" cellpadding="0" class="table">
                      <thead>
                      <tr>
                        <th style="min-width: 46px;">标题行</th>
                        <template v-for="(col, colIndex) in theadData">
                          <th :style="{'min-width': columnWidthArr[colIndex] + 'px'}">{{col}}</th>
                        </template>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, rowIndex) in tbodyData">
                        <td>{{rowIndex + 1}}</td>
                        <template v-for="col in row" >
                          <td>&nbsp;{{col}}</td>
                        </template>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </el-scrollbar>
              </div>
              <h5 style="margin-top: 10px; color: #9999a6;">说明：为了获得更流畅的体验，此处只显示前30条数据。</h5>
            </div>
          </div>
          <div v-show="activeStep === 3" style="display: none" class="import-container import-done">
            <div v-show="importTask.status === '0'" class="import-content">
              <div class="import-progress">
                <div class="import-progress-wrap">
                  <span class="progress-num">{{ importTask.percentage + '%'}}</span>
                  <div class="progress-bar">
                    <div class="progress-cur" :style="{ width: importTask.percentage + '%' }"></div>
                  </div>
                </div>
              </div>
              <p>{{ importTask.message }}</p>
            </div>
            <div v-show="importTask.status === '1'" class="import-content">
              <i style="color: #0f0;" class="mng icon-tick-fill"></i>
              <h4 style="color: #000; margin-bottom: 20px;">导入成功</h4>
              <p style="font-size: 14px;">{{ importTask.message }}</p>
            </div>
            <div v-show="importTask.status === '2'" class="import-content">
              <i style="color: #f00;" class="mng icon-cross-fill"></i>
              <p style="font-size: 14px;">{{ importTask.message }}</p>
              <a style="font-size: 14px;" class="btn-link" @click="downExcelErrorInfo">点击下载失败的数据</a>
            </div>
            <span class="assist"></span>
          </div>
        </div>
        <div v-show="activeStep === 1" style="display: none" class="popup-foot"></div>
        <div v-show="activeStep === 2" style="display: none" class="popup-foot">
          <a href="javascript:" class="btn btn-hollow" @click="handleGotoFirstStep">上一步</a>
          <a href="javascript:" class="btn btn-solid" @click="handleStartImport">提交数据</a>
        </div>
        <div v-show="activeStep === 3" style="display: none" class="popup-foot">
          <a href="javascript:" class="btn btn-solid" :style="finishBtnStyle" @click="handleFinish">完成</a>
        </div>
      </div>
    </div>
  </whaty-dialog>
</template>
<script>
  import qs from 'qs'
  import util from '../../libs/util'
  import WhatyDialog from '../dialog/dialog'

  export default {
    name: 'grid-import',
    components: {WhatyDialog},
    props: {
      importConfig: {
        required: true,
        type: Object,
        default() {
          return {
            title: '导入',
            downloadImportTemplateUrl: '', // 下载模板文件的接口地址
            downloadImportTemplateName: '', // 下载的模板文件的名称
            downloadImportTemplateExtraParams: {}, // 下载模板时传递的额外参数
            uploadUrl: '', // 上传文件并读取数据的接口地址
            uploadExtraParams: {}, // 上传文件时传递的额外参数
            startImportUrl: '', // 进行导入的接口地址
            startImportExtraParams: {}, // 进行导入时传递的额外参数
            downloadErrorInfoUrl: '', // 下载错误信息的接口地址
            sendRowId: false // 是否发送当前选择行的ids
          }
        }
      }
    },
    data () {
      return {
        visible: false, // 组件是否可见
        activeStep: 1, // 当前所在的步骤
        fileSavePath: '', // 文件上传后存储的路径
        loading: false, // 加载状态
        fileName: '', // 导入的文件名
        data: [], // 数据预览的数据
        importTask: {
          status: '0', // 导入过程的状态，0正在导入，1导入成功，2导入失败
          percentage: 0, // 导入的进度百分比
          message: ''
        }, // 导入任务
        showFinishBtn: false, // 是否显示完成按钮
        errorFilePath: '', // 错误信息下载路径
        previewFontSize: '14px' // 预览数据时字体大小
      }
    },
    computed: {
      // 下载模板的地址
      computedDownloadImportTemplateUrl() {
        return util.baseUrl + this.importConfig.downloadImportTemplateUrl
      },
      // 下载模板时传递的额外参数
      computedDownloadImportTemplateExtraParams() {
        if (this.importConfig.sendRowId) {
          if (!this.importConfig.downloadImportTemplateExtraParams) {
            this.importConfig.downloadImportTemplateExtraParams = {}
          }
          this.importConfig.downloadImportTemplateExtraParams['ids'] = this.checkedRows.join(',')
        }
        return this.importConfig.downloadImportTemplateExtraParams
      },
      // 文件上传时添加的headers
      uploadHeaders: function () {
        return {
          'Authorization': util.bearerToken()
        }
      },
      // 上传文件的地址
      computedUploadUrl() {
        return util.baseUrl + this.importConfig.uploadUrl
      },
      // 上传时传递的额外参数,根据this.sendRowId决定是否要补上checkedRows(grid选中的行)
      computedUploadExtraParams() {
        if (this.importConfig.sendRowId) {
          if (!this.importConfig.uploadExtraParams) {
            this.importConfig.uploadExtraParams = {}
          }
          this.importConfig.uploadExtraParams['ids'] = this.checkedRows.join(',')
        }
        return this.importConfig.uploadExtraParams
      },
      // 错误文件下载地址
      computedDownloadErrorInfoUrl() {
        return util.baseUrl + this.importConfig.downloadErrorInfoUrl
      },
      // 后端返回的错误文件下载地址
      computeErrorFilePath() {
        return this.errorFilePath ? (util.baseUrl + this.errorFilePath) : ''
      },
      // 数据预览：表头
      theadData() {
        return this.data && this.data.length > 0 ? this.data[0] : []
      },
      // 数据预览：数据
      tbodyData() {
        return this.data && this.data.length > 0 ? this.data.slice(1, this.data.length) : []
      },
      // 数据预览：计算列宽
      columnWidthArr() { // 计算table列宽
        let columnWidthArr = []
        let minWidth = 60
        let maxWidth = 300
        if (this.data && this.data.length > 0) {
          let rows = this.data.length
          let cols = this.data[0].length
          for (let i = 0; i < rows; i++) {
            for (let j = 0; j < cols; j++) {
              let colWidth = util.getTextDisplayWidth(this.data[i][j], this.previewFontSize) + 18
              columnWidthArr[j] = columnWidthArr[j] ? Math.max(columnWidthArr[j], colWidth, minWidth) : Math.max(colWidth, minWidth)
              columnWidthArr[j] = Math.min(columnWidthArr[j], maxWidth)
            }
          }
        }
        return columnWidthArr
      },
      // 完成按钮的style
      finishBtnStyle() {
        return {
          'visibility': (this.showFinishBtn ? 'visible' : 'hidden')
        }
      }
    },
    methods: {
      // 显示
      show() {
        this.visible = true
      },
      // 隐藏
      hide() {
        this.visible = false
      },
      // 重置导入组件的状态
      reset() {
        this.activeStep = 1
        this.fileSavePath = ''
        this.loading = false
        this.fileName = ''
        this.data = []
        this.importTask = {
          status: '0',
          percentage: 0,
          message: ''
        }
        this.showFinishBtn = false
        this.clearFiles()
      },
      // 清空已上传的文件列表
      clearFiles() {
        this.$refs.upload_file.clearFiles()
      },
      // 导入弹出框被关闭时的钩子
      handleClose() {
        this.reset()
        if (this.showFinishBtn) {
          this.$emit('finish')
        }
      },
      // 下载导入模板
      downloadTemplate() {
        let params = {tplName: this.importConfig.downloadImportTemplateName, ...this.computedDownloadImportTemplateExtraParams}
        util.useFormSubmit(this.computedDownloadImportTemplateUrl, params, true)
      },
      // 文件上传时的钩子
      uploadProgress(res, file) {},
      // 文件上传成功时的钩子
      uploadSuccess(res, file) {
        this.fileName = file.name
        if (res.meta.errCode === 0) {
          this.activeStep = 2
          this.data = res.data.excelData
          this.fileSavePath = res.data.fileSavePath
        } else {
          this.$notify.error({title: '错误', message: '上传失败，原因：' + res.meta.errMsg})
          this.clearFiles()
        }
      },
      // 文件上传失败时的钩子
      uploadError(res) {
        this.$notify.error({title: '错误', message: '上传失败, ' + res.status})
        this.clearFiles()
      },
      // 从第二步返回第一步
      handleGotoFirstStep() {
        this.$confirm('您是否要放弃提交当前的数据？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.clearFiles()
          this.activeStep = 1
        }).catch((err) => {
          console.log(err)
        })
      },
      // 提交数据,开始导入
      handleStartImport() {
        if (this.fileSavePath) {
          this.activeStep = 3
          let params = {filePath: this.fileSavePath, ...this.importConfig.startImportExtraParams}
          util.ajax.post(this.importConfig.startImportUrl, {params: params}).then((res) => {
            if (res.data.meta.errCode === 0) {
              this.$notify.info({title: '提示', message: '导入任务已启动，请稍等！'})
              this.importTask = res.data.data
              setTimeout(() => {
                this.updateImportProgress()
              }, 1000)
            } else {
              this.$notify.error({title: '错误', message: res.data.meta.errMsg})
              this.showFinishBtn = true
            }
          }).catch((e) => {
            this.showFinishBtn = true
            console.error(e)
            this.$notify.error({title: '错误', message: '启动导入任务失败'})
          })
        } else {
          this.$notify.error({title: '错误', message: '没有可导入数据'})
        }
      },
      // 导入过程中更新进度
      updateImportProgress() {
        util.ajax.post('/core/task/progress', qs.stringify({tId: this.importTask.id})).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.importTask = res.data.data
            if (this.importTask.status === '0') { // 进行中
              setTimeout(() => {
                this.updateImportProgress()
              }, 1000)
            } else if (this.importTask.status === '1') { // 成功
              this.$notify.success({title: '成功', message: '导入成功,' + this.importTask.message})
              this.showFinishBtn = true
            } else { // 失败
              this.$notify.error({title: '错误', message: '导入失败,' + this.importTask.message})
              this.errorFilePath = this.importTask.data ? this.importTask.data.errorFilePath : ''
              this.showFinishBtn = true
            }
          } else {
            this.$notify.error({title: '错误', message: '获取任务状态失败！'})
            this.showFinishBtn = true
          }
        }).catch((e) => {
          this.$notify.error({title: '错误', message: '获取任务状态失败！'})
          this.showFinishBtn = true
          console.error(e)
        })
      },
      // 下载错误信息文件
      downExcelErrorInfo() {
        let params = {fileDownPath: this.fileSavePath, fileName: this.importConfig.downloadImportTemplateName}
        // 优先使用后端返回的错误信息下载路径
        util.useFormSubmit(this.computeErrorFilePath || this.computedDownloadErrorInfoUrl, params, true)
      },
      // 完成按钮
      handleFinish() {
        this.hide()
        this.$emit('finish')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid/grid-import.vue